import { render, staticRenderFns } from "./detail_play.vue?vue&type=template&id=d816f756&"
import script from "./detail_play.vue?vue&type=script&lang=ts&"
export * from "./detail_play.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports